import { ReactNode, useEffect, useState } from "react";
import { Form, Tooltip } from "@douyinfe/semi-ui";
import { IconHelpCircle } from "@douyinfe/semi-icons";
import { CrudOption } from "../../comp/crud";

export interface AsyncSelectProps {
  options: () => Promise<CrudOption[]>;
  field: string;
  label: string | number;
  disabled?: boolean;
  popoverHelp?: ReactNode;
  onChange?: (value: any) => void;
}

export function AsyncSelect(props: AsyncSelectProps) {
  const [options, setOptions] = useState([] as CrudOption[]);
  useEffect(() => {
    props.options().then((opts) => setOptions(opts));
  }, []);
  return (
    <Form.Select
      onChange={props.onChange}
      disabled={props.disabled}
      style={{ width: "100%" }}
      field={props.field}
      label={{
        text: props.label,
        extra: props.popoverHelp ? (
          <Tooltip style={{ maxWidth: 400 }} content={props.popoverHelp}>
            <IconHelpCircle style={{ color: "var(--semi-color-text-2)" }} />
          </Tooltip>
        ) : undefined,
      }}
    >
      {options.map((o) => (
        <Form.Select.Option disabled={o.disabled} key={o.key} value={o.value}>
          {o.label}
        </Form.Select.Option>
      ))}
    </Form.Select>
  );
}
